<div class="reader-ui-tooltip__surface">
  <div class="reader-ui-tooltip__arrow"></div>
  <div class="reader-ui-tooltip__inner" role="tooltip">
    @if (templateRef(); as template) {
      <ng-container
        [ngTemplateOutlet]="template"
        [ngTemplateOutletContext]="{ tooltipMessage: tooltipMessage() }"
      />
    } @else {
      <div cdkFocusInitial>{{ tooltipMessage() }}</div>
    }
  </div>
</div>